<div class="flex flex-wrap gap-4">
  <div class="flex flex-row gap-3">
    <mat-slide-toggle
      [checked]="checked"
      [disabled]="disabledToggle"
      (change)="toggleChange.emit($event)"
    ></mat-slide-toggle>
    <div class="flex flex-col">
      <p class="text-[18px] font-normal">{{ title }}</p>
      <span class="setting-description">{{ description }}</span>
    </div>
  </div>
  <ng-container *ngIf="isShowPill">
    <app-pill
      *ngIf="isSubscriptionActive; else subscriptionNotActive"
      [type]="pillType.brandInverted"
    >
      {{ subscriptionLabel | translate }}</app-pill
    >
  </ng-container>
</div>

<ng-template #subscriptionNotActive>
  <app-pill [type]="pillType.brand">
    <mat-icon class="lock-icon">lock</mat-icon>
    {{ subscriptionLabel | translate }}
  </app-pill>
</ng-template>
